module.exports = __webpack_public_path__ + "img/icon_map_188_off_010.a4cd5081.png";